/*
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-10-10 17:04:56
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-10 17:11:33
 * @FilePath: /pegasus-web-vehicle/src/store/hooks.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { reactive, computed, getCurrentInstance } from 'vue'
import Vuex from 'vuex'

// 访问vuex
export const useStore = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$store
}

// 访问router
export const useRouter = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$router
}

// 访问route
export const useRoute = () => {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('must be called in setup')
  return vm.proxy.$route
}

// 判断访问权限
export const usePermission = () => {
  const store = useStore()
  const allResource = store.getters.allResource || []
  return (key) => {
    return allResource.includes(key)
  }
}

// 创建一个统一的处理方法
function useStoreMapper(mapFn, mapper, isComputed) {
  const store = useStore()
  const storeStateFns = mapFn(...mapper)
  const storeState = {}
  Object.keys(storeStateFns).forEach((fnKey) => {
    // 需要绑定store实例
    const fn = storeStateFns[fnKey].bind({ $store: store })
    // state和getters需要通过computed实现响应式
    // mutatuons和actions不需要响应式
    storeState[fnKey] = isComputed ? computed(fn) : fn
  })
  // 使用reactive包装一下，使用的时候就不需要再.value了
  return reactive(storeState)
}


// 映射mapState
export function useStoreState(...mapper) {
  return useStoreMapper(Vuex.mapState, mapper, true)
}

// 映射mapGetters
export function useStoreGetters(...mapper) {
  return useStoreMapper(Vuex.mapGetters, mapper, true)
}

// 映射mapMutations
export function useStoreMutations(...mapper) {
  return useStoreMapper(Vuex.mapMutations, mapper, false)
}

// 映射mapActions
export function useStoreActions(...mapper) {
  return useStoreMapper(Vuex.mapActions, mapper, false)
}

// 千分位转换
export function useNumberWithCommas(x) {
  if (!x) return '0.00'
  // 保留两位补 0
  let value = Math.round(parseFloat(x) * 100) / 100
  const s = value.toString().split('.')
  if (s.length === 1) {
    value = `${value.toString()}.00`
  }
  if (s.length > 1) {
    if (s[1].length < 2) {
      value = `${value.toString()}0`
    }
  }
  // 千分位
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function useFormatEnumeration(arrayData) {
  const list = {}
  arrayData.forEach((item) => {
    list[item.code] = item.name
  })
  return list
}
